import {LayoutConfig} from "@spartacus/storefront";

export const GonvarriLayoutConfig: LayoutConfig = {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
  },
  layoutSlots: {
    StockContentTemplate: {
      slots: [
        'QuickStockTextName',
        'QuickStockTableName'
      ]
    }
  },
};
